import { useTracking } from "@/hooks/useTracking";
import { useScrollSpy } from "./useScrollSpy";
import "./styles.scss";

export interface SideNavItem {
  id: string;
  label: string;
}

interface SideNavProps {
  items: SideNavItem[];
  variant?: "isp" | "mvno";
}

/**
 * Notion-style right-edge section rail: a stack of short dashes, one per
 * section on the page. The active one grows and fills; hovering any of them
 * pops a glass tooltip with the section name. Desktop only (>=1180px) — on
 * a page this narrow the rail would fight the content for space.
 */
export const SideNav = ({ items, variant = "isp" }: SideNavProps) => {
  const ids = items.map((i) => i.id);
  const active = useScrollSpy(ids);
  const { sendEvent } = useTracking();

  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    sendEvent("button_clicked", {
      event_category: "side_nav",
      event_label: id,
      event_action: "click",
      value: 1,
    });
  };

  return (
    <nav className={`side-nav side-nav--${variant}`} aria-label="Navegação da página">
      {items.map((item) => (
        <button
          key={item.id}
          className={`side-nav__dot ${active === item.id ? "is-active" : ""}`}
          onClick={() => goTo(item.id)}
          aria-label={item.label}
          aria-current={active === item.id}
        >
          <span className="side-nav__bar" />
          <span className="side-nav__tooltip">{item.label}</span>
        </button>
      ))}
    </nav>
  );
};
